import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter  } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import { LazyMotion, domAnimation } from 'framer-motion'
import store, { persistor } from './store'
import Theme from 'components/template/Theme'
import Layout from 'components/layout'
import RouteErrorBoundary from 'components/route/RouteErrorBoundary'
import history from './history'
import './locales'

function App() {
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<BrowserRouter history={history}>
					<LazyMotion features={domAnimation}>
						<Theme>
							<RouteErrorBoundary fullPage>
								<Layout />
							</RouteErrorBoundary>
						</Theme>
					</LazyMotion>
				</BrowserRouter >
			</PersistGate>
		</Provider>
	)
}

export default App
